import React from 'react'

import SoftwareReportContext from '../SoftwareReportContext'
import { OperatingSystemFilters } from '../Filters'
import CloudCoreSummary from '../Summary'
import VMTable from '../VMTable'

const OperatingSystemSummary = ({ data }) => (
  <SoftwareReportContext.Consumer>
    {({ filterOptions, filters, changeFilters, toggleSummary }) => (
      <CloudCoreSummary {...{ data, Filters: OperatingSystemFilters }}>
        <button className="button__link p-0" onClick={() => toggleSummary(true, 'operating_systems')}>
          Show summary
        </button>
        <OperatingSystemFilters {...{ filters, filterOptions, changeFilters }} />

        <VMTable {...{ data }} />
      </CloudCoreSummary>
    )}
  </SoftwareReportContext.Consumer>
)

export default OperatingSystemSummary
